import { render, staticRenderFns } from "./VersionsTable.vue?vue&type=template&id=8f7c1b6e&scoped=true"
import script from "./VersionsTable.vue?vue&type=script&lang=js"
export * from "./VersionsTable.vue?vue&type=script&lang=js"
import style0 from "./VersionsTable.vue?vue&type=style&index=0&id=8f7c1b6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c1b6e",
  null
  
)

export default component.exports